var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { MultiselectList } from "../../../../../../../../Components/UI";
import { formatTemplatesToOptions } from "../../../../../utils/formatters";
import { useAtomValue } from 'jotai';
import { templatesAtom } from "../../../../../../../../atoms";
import { useCreateExtractorContext } from "../../CreateExtractorContext";

const Body = () => {
  const { sourceTemplateId, setSourceTemplateId, targetTemplateId } = useCreateExtractorContext();
  const templates = useAtomValue(templatesAtom);
  const sourceTemplateOptions = formatTemplatesToOptions(
    templates.filter((template) => template._id !== targetTemplateId)
  );

  return (/*#__PURE__*/
    _jsx("div", {}, void 0, /*#__PURE__*/
    _jsx(MultiselectList, {
      value: [sourceTemplateId],
      items: sourceTemplateOptions,
      onChange: (selected) => {
        setSourceTemplateId(selected[0]);
      },
      allowSelelectAll: false,
      singleSelect: true,
      className: "min-h-[500px]",
      itemContainerClassName: "max-h-[400px] overflow-y-auto my-4" }
    )
    ));

};

export { Body };